"use strict";

(function ($, FUNCTIONS) {})(window.jQuery, window.FUNCTIONS);